import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { distinct } from 'rxjs/operators';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { UserService } from 'src/services/user.service';
import { PlayerService } from '../players/players.service';

@Component({
  selector: 'tiebreak-signup',
  templateUrl: './tiebreaksignup.component.html',
  styleUrls: ['tiebreaksignup.component.scss']
})
export class TiebreakSignupComponent implements OnInit {
  public busy: boolean = false;
  public isAuthenticated: boolean = false;
  public newLadderForm: FormGroup;

  constructor(private authorizeService: AuthorizeService,
    private userSvc: UserService, private http: HttpClient,
    private router: Router, private playerSvc: PlayerService,
    private aRoute: ActivatedRoute) {
    this.busy = false;

    this.newLadderForm = new FormGroup({
      ladderId: new FormControl('2022-1-TIEBREAK'),
      levelId: new FormControl(5),
    });
    // make sure the level id selected is a NUMBER
    this.newLadderForm.controls.levelId.valueChanges
      .pipe(distinct())  // avoid infinite loop
      .subscribe(val => this.newLadderForm.controls.levelId.setValue(+val));
  }

  ngOnInit(): void {

  }

  public showpay: boolean = false;
  public submit(): void {
    this.busy = true;
    console.log(this.newLadderForm.value);
    //if( this.newLadderForm.value.ladderId == '' || this.newLadderForm.levelId)
    this.http.post('/api/joinladder', this.newLadderForm.value).subscribe(
      (resp: { status: string }) => {
        if (resp.status == "registered") {
          this.userSvc.clearCache();
          localStorage.setItem('ladderId', this.newLadderForm.value.ladderId);
          localStorage.setItem('levelId', '' + this.newLadderForm.value.levelId);
          this.busy = false;
          this.showpay = true;
        }
        else alert(resp.status)
      },
      (resp: { error: any }) => {
        alert(resp.error.status);
        this.busy = false;
      }
    )
  }

}
